import * as Types from "../actionTypes/mediaStreamTypes";

export const setCamStreamState = (payload) => ({
  type: Types.SET_DEVICE_CAM_STREAM,
  payload,
});
export const setScreenStreamState = (payload) => ({
  type: Types.SET_DEVICE_SCREEN_STREAM,
  payload,
});
export const setVideoState = (payload) => ({
  type: Types.SET_DEVICE_VIDEO,
  payload,
});
export const setAudioState = (payload) => ({
  type: Types.SET_DEVICE_AUDIO,
  payload,
});
export const setMediaStreamInit = (payload) => ({
  type: Types.SET_DEVICE_INIT,
  payload,
});
